export default {
  'primary': '#1F4684',
  'secondary': '#A8974F',
  'accent': '#0844a3'
}
